import React from 'react';

import { annotationIconsList } from 'react-scale/components/website/big/content/icons/AnnotationIcons';

const AnnotationPill = ({ icon, name, fill, task }) => {
  const Icon = annotationIconsList[icon];
  return (
    <div className="flex items-center">
      <span className="w-6 h-6 block mr-2 shrink-0">
        <Icon className={fill} />
      </span>
      <span className="text-sm text-neutral-900">
        {name} {task && 'Task'}
      </span>
    </div>
  );
};

AnnotationPill.defaultProps = {
  task: false
};

export default AnnotationPill;
